import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';

import { NotificationItemDTOCategory, NotificationItemDTOStatus } from '@/api';
import { log } from '@/utils/functions/logger/logger';

type NotificationVisual =
  { kind: 'icon'; iconId: TotemIconId; variant: 'alert' | 'info' } | { kind: 'megaphone'; variant: 'offers' };

/**
 * Category wins over status: an offer always gets the megaphone, whatever its importance level.
 * Unknown statuses fall back to the info treatment (logged, not silently dropped).
 * The variant only names the color treatment — the colors themselves live in styles.module.css.
 */
const getNotificationVisual = (
  status: NotificationItemDTOStatus | null | undefined,
  category: NotificationItemDTOCategory | null | undefined
): NotificationVisual => {
  if (category === NotificationItemDTOCategory.OFFERS) {
    return { kind: 'megaphone', variant: 'offers' };
  }

  if (status === NotificationItemDTOStatus.URGENT || status === NotificationItemDTOStatus.WARNING) {
    return { kind: 'icon', iconId: 'warning', variant: 'alert' };
  }

  if (status && status !== NotificationItemDTOStatus.INFO) {
    log.warn(`getNotificationVisual: unknown status "${status}", falling back to info`);
  }

  return { kind: 'icon', iconId: 'info-circle', variant: 'info' };
};

export { getNotificationVisual };
export type { NotificationVisual };
